module.exports = __webpack_public_path__ + "media/images/regions_old/Niamey-5a54549d914c247f8135595863c69ac4.png";